"use strict";

exports.__esModule = true;
exports.ItemTypeItemPath = ItemTypeItemPath;
exports.ItemTypeTitle = ItemTypeTitle;
exports.ItemTypePath = exports.ItemTypeSegment = void 0;

var _getPath = require("../../../../../react-static/route/getPath");

var _Packing = require("../Packing");

var ItemTypeSegment = "item-type";
exports.ItemTypeSegment = ItemTypeSegment;
var ItemTypePath = (0, _getPath.getPath)(ItemTypeSegment, _Packing.PackingPath);
exports.ItemTypePath = ItemTypePath;

function ItemTypeItemPath(itemSlug) {
  return (0, _getPath.getPath)(itemSlug, ItemTypePath);
}

function ItemTypeTitle(name) {
  return name + " - Item Type";
}